
import {
  Person as PersonIcon,
  CalendarToday as CalendarIcon,
  AccessTime as TimeIcon,
  // AttachMoney as MoneyIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Schedule as ScheduleIcon,
  FormatListBulleted as FormatIcon,
  PendingOutlined as PendingOutlinedIcon,
  // Edit as EditIcon
} from '@mui/icons-material';
import { ENV_DECLARONS, getActivePrestationBrandConfig, isBrandActive } from '../config/environment.config';

// {isSuccess ? (
//   <CheckCircleIcon className="w-5 h-5 text-green-500" />
// ) : isError ? (
//   <WarningIcon className="w-5 h-5 text-red-500" />
// ) : isPending ? (
//   <WarningIcon className="w-5 h-5 text-amber-500" />
// ) : (
//   <ScheduleIcon className="w-5 h-5 text-blue-500" />
// )}
export enum UrssafServiceStatEnum {
  STATUS_10_INTEGRATED = "INTEGRATED",
  STATUS_20_WAITING = "WAITING_FOR_VALIDATION",
  STATUS_30_VALIDATED = "VALIDATED",
  STATUS_40_REFUSAL = "REFUSED",
  STATUS_50_COLLECTED = "COLLECTED",
  STATUS_60_REFUSAL_OF_DIRECT_DEBIT = "REFUSAL_OF_DIRECT_DEBIT",
  STATUS_70_PAID = "PAID",
  STATUS_110_CANCELED = "CANCELED",
  STATUS_111_CANCELED_111 = "CANCELED 111",
  STATUS_112_CANCELED_112 = "CANCELED 112",
  STATUS_120_COVERED = "COVERED",
  ERROR = "ERROR",
  COURS_PREVU = "COURS_PREVU",
  EN_COURS = "EN_COURS",
}
const colorClasses = {
  ALERT: "text-third border-orange bg-orange bg-opacity-10", // Alerte / Blocage
  WARNING: "text-yellow-500 border-yellow-500 bg-yellow-500 bg-opacity-10", // En attente / En cours
  INFO: "text-blue-400 border-blue-400 bg-blue-400 bg-opacity-10", // Infos administratives
  INFO_LIGHT: "text-blue-300 border-blue-300 bg-blue-300 bg-opacity-10", // Infos administratives
  SUCCESS_LIGHT: "text-green-400 border-green-400 bg-green-400 bg-opacity-10", // Succès léger
  SUCCESS_DARK: "text-green-600 border-green-600 bg-green-600 bg-opacity-10", // Succès validé
  ERROR: "text-red-500 border-red-500 bg-red-500 bg-opacity-10", // Erreur critique
  NORMAL: "text-normal border-normal bg-normal bg-opacity-10", //
};

export enum UrssafServiceStatusDescription {
  STATUS_INTEGRATED = "La demande de paiement a été reçue et a passé les différents contrôle de cohérence",
  STATUS_WAITING_FOR_VALIDATION = "Le particulier a été prévenu que la demande de paiement est à valider/rejeter par lui",
  STATUS_VALIDATED = "La demande de paiement a été validée par le particulier et le circuit de prélèvement est lancé",
  STATUS_REFUSED = "La demande de paiement est refusée par le particulier : il a renseigné son rejet et un code motif associé",
  STATUS_COLLECTED = "La demande de paiement a été payée avec succès par le particulier (le RAC uniquement)",
  STATUS_REFUSAL_OF_DIRECT_DEBIT = "Le prélèvement associé à la demande de paiement est revenu en erreur . La demande de paiement est en impayée.",
  STATUS_PAID = "La demande de paiement a été validée par votre client. Il sera prélevé prochainement ou a déjà été prélevé par l’URSSAF",
  STATUS_CANCELED = "La demande de paiement a été annulée par le particulier.",
  STATUS_CANCELED_111 = "La demande de paiement a été annulée après impayé du particulier.",
  STATUS_CANCELED_112 = "La demande de paiement a été annulée après recouvrement par le prestataire.",
  STATUS_COVERED = "La demande de paiement en impayé a été recouvrée par le prestataire",
  ERROR = "Erreur inconnue, veuillez contacter le service client",
  COURS_PREVU = "Votre cours est à venir",
  EN_COURS = "Votre cours est terminé : la demande de paiement n'a pas encore été transmise à l'URSSAF.",
}

export const UrssafServiceStatEnumColor = {
  STATUS_10_INTEGRATED: {
    title: "Transmis",
    value: "10",
    color: colorClasses.INFO_LIGHT,
    icon : <ScheduleIcon className={`w-5 h-5 text-blue-300`} />,
  }, // 🔵 Infos administratives -> la demande est Transmis
  STATUS_20_WAITING: {
    title: "En attente",
    value: "20",
    color: colorClasses.WARNING,
    icon : <ScheduleIcon className={`w-5 h-5 text-yellow-500`} />,
  }, // 🟡 En attente -> la demande est en attente de validation
  STATUS_30_VALIDATED: {
    title: "Validé",
    value: "30",
    color: colorClasses.SUCCESS_LIGHT,
    icon : <CheckCircleIcon className="w-5 h-5 text-green-400 " />,
  }, // 🟢 Succès validé -> le circuit de prélèvement est lancé
  STATUS_40_REFUSAL: {
    title: "Refusé",
    value: "40",
    color: colorClasses.ERROR,
    icon : <WarningIcon className="w-5 h-5 text-red-500" />,
  }, // 🔴 Erreur -> la demande est refusée par le particulier
  STATUS_50_COLLECTED: {
    title: "Collecté",
    value: "50",
    color: colorClasses.INFO,
    icon : <CheckCircleIcon className="w-5 h-5 text-blue-400" />,
  }, // 🔵 Infos administratives -> la demande est collectée
  STATUS_60_REFUSAL_OF_DIRECT_DEBIT: {
    title: "Refus de prélèvement",
    value: "60",
    color: colorClasses.ALERT,
    icon : <WarningIcon className="w-5 h-5 text-third" />,
  }, // 🟠 Alerte -> impayé, prélèvement en erreur
  STATUS_70_PAID: {
    title: "Prélevée",
    value: "70",
    color: colorClasses.SUCCESS_DARK,
    icon : <CheckCircleIcon className="w-5 h-5 text-green-600" />,
  }, // 🟢 Succès validé -> virement de paiement lancé
  STATUS_110_CANCELED: {
    title: "Annulé",
    value: "110",
    color: colorClasses.ERROR,
    icon : <WarningIcon className="w-5 h-5 text-red-500" />,
  }, // 🔴 Erreur -> demande annulée par le particulier
  STATUS_111_CANCELED_111: {
    title: "Annulé après impayé",
    value: "111",
    color: colorClasses.ERROR,
    icon : <WarningIcon className="w-5 h-5 text-red-500" />,
  }, // 🔴 Erreur -> annulée après impayé
  STATUS_112_CANCELED_112: {
    title: "Annulé après recouvrement",
    value: "112",
    color: colorClasses.ERROR,
    icon : <WarningIcon className="w-5 h-5 text-red-500" />,
  }, // 🔴 Erreur -> annulée après recouvrement
  STATUS_120_COVERED: {
    title: "Couvert",
    value: "120",
    color: colorClasses.SUCCESS_DARK,
    icon : <CheckCircleIcon className="w-5 h-5 text-green-600" />,
  },
  ERROR: { title: "Erreur", value: "ERROR", color: colorClasses.ERROR, icon : <WarningIcon className="w-5 h-5 text-red-500" />, }, // 🔴 Erreur critique
  // Cours terminé, demande de paiement pas encore partie à l'URSSAF (aucun statut URSSAF ni statut de déplacement).
  EN_COURS: { title: "En attente de transmission", value: "null", color: colorClasses.INFO_LIGHT,  icon : <PendingOutlinedIcon className={`w-5 h-5 text-blue-300`} />, },
  COURS_PREVU: { title: "Cours à venir", value: "null", color: colorClasses.NORMAL,  icon : <ScheduleIcon className={`w-5 h-5 text-normal`} />, },
};

// ─── P5 – Statut de déclaration selon la distance prof/client ────────────────

export enum DeclarationStatusEnum {
  DECLARED = "declared",
  PENDING_VERIFICATION = "pending_verification",
  PENDING_APPROVAL = "pending_approval",
  REJECTED = "rejected",
}

// Mots de marque (la marque est fixée au build via REACT_APP_BRAND) :
// cours (Teach'r / Verified Trainer) ou prestation (Déclarons, féminin)
const prestationWord = getActivePrestationBrandConfig();
const prestationFem = isBrandActive(ENV_DECLARONS) ? "e" : "";
const lePrestation = getActivePrestationBrandConfig("", "le ", "la ");

export const DeclarationStatusEnumColor = {
  PENDING_VERIFICATION: {
    title: "Attestation à vérifier",
    value: DeclarationStatusEnum.PENDING_VERIFICATION,
    color: colorClasses.WARNING,
    icon: <ScheduleIcon className="w-5 h-5 text-yellow-500" />,
    description:
      `Votre ${prestationWord} est bien déclaré${prestationFem}. Votre attestation sur l'honneur de déplacement est en cours de vérification par notre équipe : aucune action n'est requise de votre part.`,
  }, // 🟡 statut hérité de l'ancienne règle 60–160 km : déclaré, contrôle a posteriori
  PENDING_APPROVAL: {
    title: "En attente d'approbation",
    value: DeclarationStatusEnum.PENDING_APPROVAL,
    color: colorClasses.ALERT,
    icon: <PendingOutlinedIcon className="w-5 h-5 text-third" />,
    description:
      `Votre ${prestationWord} est enregistré${prestationFem} mais pas encore déclaré${prestationFem} : la distance dépasse 160 km, votre preuve de déplacement doit d'abord être approuvée par notre équipe.`,
    /** Même statut avec le motif réel posé par le serveur (ex. adresse identique à celle du client). */
    descriptionWithReason: (reason: string) =>
      `Votre ${prestationWord} est enregistré${prestationFem} mais pas encore déclaré${prestationFem} : ${reason.charAt(0).toLowerCase()}${reason.slice(1)}. La déclaration doit d'abord être approuvée par notre équipe.`,
  }, // 🟠 > 160 km ou adresse identique : enregistré mais non déclaré tant que l'admin n'a pas approuvé
  REJECTED: {
    // Rejet avec motif = seconde chance : le libellé invite à renvoyer un justificatif.
    title: "Justificatif à renvoyer",
    value: DeclarationStatusEnum.REJECTED,
    color: colorClasses.ERROR,
    icon: <WarningIcon className="w-5 h-5 text-red-500" />,
    description:
      `Votre justificatif de déplacement n'a pas encore pu être validé : ${lePrestation} n'est pas encore déclaré${prestationFem}. Envoyez un nouveau justificatif pour que notre équipe l'étudie de nouveau, ou contactez le support.`,
  }, // 🔴 rejeté par l'admin avec motif, cours non déclaré tant qu'un nouveau justificatif n'est pas validé
};
